import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from './auth.service';

@Injectable({providedIn: 'root'})
export class AdminGuard implements CanActivate {
    constructor(
        private as :AuthService , 
      private router:Router

    ) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot)  : Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree{
        return new Promise(resolve => {
            this.as.User.subscribe(user => {
                console.log();
                
              if (user && user.email === "admin@admin.com") {
                resolve(true);
              }
              else {
                this.router.navigate(["/"]);
              }
            });
          });    }
}